import { NavigateFunction } from 'react-router-dom';

export type ResetPasswordScreen = 'otp' | 'changePassword';

export interface ResetPasswordViewModel {
  screen: ResetPasswordScreen;
  phone: string | null;
  isContacted: boolean;
  userId: number | null;
  otp: string | null;
  navigate: NavigateFunction | null;

  verifyOtp: (rawOtp: any) => Promise<void>;
  changePassword: (password: string) => Promise<void>;
}

export const ResetPasswordViewModelToken = Symbol.for('ResetPasswordViewModel');
